import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import ColorSelection, { setPositionColorName } from '../components/ColorSelection';
import ConvertHeight from '../components/ConvertHeight';
import ADA from '../components/ADA';
import { isDesktop } from '../utils';

export default class ModTrimSelection {
  constructor(el) {
    this.$el = $(el);

    this.classes = {
      trimContentActive: 'trim-content-active',
      tagWrapActive: 'tag-wrap-active',
      hiddenCls: 'hidden',
      tmpClassActive: 'xl:relative xl:opacity-100 z-2',
    };

    this.attributes = {
      tabindex: 'tabindex',
    };

    this.elementClasses = {
      modelItemSelector: '.js-model-item',
      swiperSlide: '.swiper-slide',
    };

    this.dom = {
      $currentStrimsIndex: this.$el.find('.current-trim-index'),
      $trimItemContentDesktop: this.$el.find('.wrap-trims-desktop'),
      $swiperEl: this.$el.find('.slider-trims'),
      $nextEl: this.$el.find('.swiper-button-next'),
      $prevEl: this.$el.find('.swiper-button-prev'),
      $models: this.$el.find('.js-model-item'),
      $colorsWrap: this.$el.find('.js-colors-wrap'),
      $colorBg: this.$el.find('.js-color-bg'),
      $colorName: this.$el.find('.js-color-name'),
      $trimWrap: this.$el.find('.js-trim-wrap'),
      $tagWrap: this.$el.find('.js-trims-tag-wrap'),
      $heightItem: this.$el.find('.convert-height'),
    };

    this.adaInstance = new ADA();
    this.init();
  }

  init() {
    this.changeColorModelEvent();
    this.addSwiper();
    this.callConvertHeight();
    this.setPositionForColorName();
    this.initADA();
    $(window).on('resize orientationchange', () => {
      setTimeout(() => {
        this.callConvertHeight();
        this.setPositionForColorName();
      }, 1000);
    });
  }

  changeColorModelEvent() {
    this.dom.$colorsWrap.each((_i, el) => {
      const colorSelection = new ColorSelection(el);
      const $model = $(el).closest(this.elementClasses.modelItemSelector);
      const $closestTrimWrap = $(el).closest('.js-trim-wrap');
      const $radios = $model.find('.js-color-radio');
      const $modelThumb = $model.find('.js-thumb');

      colorSelection.changeColorEvent(($radio) => {
        const indexOfWrap = this.dom.$trimWrap.index($closestTrimWrap);

        // get thumb inage match with index of wrap in slider
        const $thumb = this.dom.$swiperEl.find(this.elementClasses.swiperSlide).eq(indexOfWrap).find('.js-thumb');
        const idx = $radios.index($radio);
        $modelThumb.addClass(this.classes.hiddenCls);
        $modelThumb.eq(idx).removeClass(this.classes.hiddenCls);
        $thumb.addClass(this.classes.hiddenCls);
        $thumb.eq(idx).removeClass(this.classes.hiddenCls);
        this.setPositionForColorName();
      });
    });
  }

  callConvertHeight() {
    const converter = new ConvertHeight(this.dom.$heightItem);
    converter.convertHeight();
  }

  addSwiper() {
    if (this.dom.$swiperEl.length && this.dom.$swiperEl.find(this.elementClasses.swiperSlide).length > 1) {
      const swiperElm = this.dom.$swiperEl.get(0);
      this.mySwiper = new Swiper(swiperElm, {
        modules: [Navigation, A11y],
        speed: 700,
        navigation: {
          nextEl: this.dom.$nextEl.get(0),
          prevEl: this.dom.$prevEl.get(0),
        },
        on: {
          transitionEnd: () => {
            this.adaInstance.removeAttrAriaDisabled(this.$el);
          },
        },
      });

      this.mySwiper.on('slideChange', (swiper) => {
        const { activeIndex } = swiper;
        this.dom.$currentStrimsIndex.text(activeIndex + 1);
        this.dom.$trimWrap.removeClass(this.classes.trimContentActive).removeClass(this.classes.tmpClassActive);
        this.dom.$trimWrap.eq(activeIndex).addClass(this.classes.trimContentActive);
        this.dom.$tagWrap.removeClass(this.classes.tagWrapActive).fadeOut(0);
        this.dom.$tagWrap.eq(activeIndex).addClass(this.classes.tagWrapActive).stop().fadeIn(500);

        // ADA
        this.addTabindexADA(this.dom.$trimWrap);
        this.removeTabindexADA(this.dom.$trimWrap.eq(activeIndex));
      });

      this.adaInstance.removeAttrAriaDisabled(this.$el);
    }
  }

  setPositionForColorName() {
    this.dom.$colorsWrap.each((_i, wrapElm) => {
      const $wrapElm = $(wrapElm);
      const $colorBg = $wrapElm.find('.js-color-bg');
      const $colorName = $wrapElm.find('.js-color-name');
      $colorBg.each((_i2, el) => {
        const $el = $(el);
        if ($el.find('input:checked').length) {
          if (isDesktop()) {
            setPositionColorName($wrapElm.get(0), $el.get(0), $colorName.get(0));
          } else {
            $colorName.css({ transform: '' });
          }
        }
      });
    });
  }

  initADA() {
    this.addTabindexADA(this.dom.$trimWrap);
    this.removeTabindexADA(this.dom.$trimWrap.eq(0));
  }

  addTabindexADA($parent) {
    $parent.find('a, button, input').attr(this.attributes.tabindex, '-1');
  }

  removeTabindexADA($parent) {
    $parent.find('a, button, input').removeAttr(this.attributes.tabindex);
  }
}
